module.exports = __webpack_public_path__ + "static/img/Jack-deBelin.80f20b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Jack-deBelin.jpg
// module id = v+B6
// module chunks = 0